import React ,{useEffect} from 'react';
import AOS from 'aos';
import LogInForm from '../Components/Pages/LogIn/LogInForm';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function LogIn(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <LogInForm />
        <Footer />
        </>
    )
};
export default LogIn;